import {Component} from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight, faCaretDown } from '@fortawesome/free-solid-svg-icons';
import WaitTimeSpinner from '../../shared-components/wait_time_spinner';
import InvestmentDetailInfoCard from './investment_detail_info_card';
import { setHeadersForFetch } from '../../../objects/CommonUse/set_headers_for_fetch';
import buildUrl from '../../../objects/CommonUse/build_URL';
import Config from '../../../config';
import { doubleToStringMonthly } from '../../../objects/CommonUse/double_functions';
import InvestmentPriceGraph from './investment_price_graph';
import { rollBackwardDate } from '../../game-views/objects/roll_backward_date_function';
import InvestmentGeneralInfoCard from './investment_general_info_card';

class InvestmentBuyInfoCard extends Component {
    constructor(props) {
        super(props);
        this.moneyBuildInfo = this.props.moneyBuildInfo();
        this.state = {open: false, 
            selected: false,
            investmentDetailLoaded: false,
            headers: setHeadersForFetch(),
            subProcess: "investmentGeneralInfoCard",
            environment: Config.dataURL.currentEnv,
            errorFound: false,
            timeout: "",
            purchaseQuantity: ""
        };
        this.investmentDetailData = {};
        this.errorMsg = "";
        this.purchasePrice = undefined;
        this.determineKeyDateInfo();
        this.buyDates = [];
        this.investType = "";
    }

    determineKeyDateInfo(){
        this.currentMonthNbr = +this.moneyBuildInfo.totalNbrGameMonths - +this.moneyBuildInfo.gameData.gameNbrMonths;
        this.firstMonthDate = rollBackwardDate(this.moneyBuildInfo.gameData.currentGameDate, 12);
    }    
    
    toggleDetailInfo(investShortName) {
        this.displayGraph = true;
        //  do not show price graph if it is a bond because the price graph is mostly a straight line
        if (this.props.investInfo.currentPrice === +0 || this.props.investType === "bond"){
            this.displayGraph = false;
        }
        this.loadInvestmentDetail(investShortName);
        this.setState({open: !this.state.open});
    }

    onPurchaseQuantity(purchaseQty){
        this.setState({purchaseQuantity: purchaseQty});
        if(this.state.timeout) clearTimeout(this.state.timeout);
                this.state.timeout = setTimeout(() => {
                this.processPurchaseEntry(purchaseQty);
        }, 500);
    }

    processPurchaseEntry(purchaseQuantity){
        this.editPurchaseQty(purchaseQuantity);
        if (this.qtyError === false){
            let returnObj = {shortName: this.props.investInfo.investShortName, 
                quantity: purchaseQuantity, totalAmount: this.purchasePrice,
                currentPrice: this.props.investInfo.currentPrice, tranType: "buy",
                transNbr: 1};
             this.props.onPurchaseInvestment(returnObj);
        }
        this.setState({errorFound: this.qtyError});
    }

    editPurchaseQty(purchaseQuantity){ 
        this.qtyError = false;
        this.errorMsg = "";
        if (isNaN(+purchaseQuantity)){
            this.errorMsg = "Quantity Must be Numeric";
            this.purchasePrice = undefined;
            this.qtyError = true;
        }else{
            this.purchasePrice = (this.props.investInfo.currentPrice * purchaseQuantity).toFixed(2);
            if (+this.purchasePrice > +this.moneyBuildInfo.gameData.currentCash){
                this.errorMsg = "Price of this purchase exceeds current cash.";
                this.qtyError = true;
            }
        }
    }

    combineInvestCategory(){
        //  this process ensures that the category is only displayed in the 'card' when it changes
        this.previousCategory = "";
        this.investDetailArr = [];
        for (let i=0; i<this.investmentDetailData.informationArr.length; i++){
            const investDetail = JSON.parse(JSON.stringify(this.investmentDetailData.informationArr[i]));
            if (investDetail.infoCat !== this.previousCategory){
                this.previousCategory = investDetail.infoCat;
            }else{
                investDetail.infoCat = "";
            }
            this.investDetailArr.push(investDetail);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.investType !== this.props.investType) {
            this.setState({ purchaseQuantity: "" });
            this.investType = this.props.investType;
            this.purchasePrice = "";
            // You can also reset purchasePrice or other instance variables here
        }
    }

    render() {
        const defaultImgSrc="./assets/Investments/" + this.props.investInfo.imageUrl;
        if (this.investmentDetailData.informationArr){
            this.combineInvestCategory();
            this.stockDetailInfo = this.investDetailArr.map((investment, index) =>
                <InvestmentDetailInfoCard key={index} investInfo={investment} 
                    investCategory={this.previousCategory}
                    />
            );
        
        }
    return <>
   
        <div className="card mx-3 my-2 drop-shadow"></div>
           <div className="card-header text-left">
                <span className="container m-0 p-0">
                    <span className="mx-2 row w-100 my-0">
                        <div className="col-sm-1">
                           <img src={defaultImgSrc} className="medium_sign_thumbnail_img" alt="logo"/>
                       </div>    
                        <div className="col-sm-9">
                            <h5 className="text-center">
                                    {this.props.investInfo.investmentName}
                            </h5>
                        </div>
                        <div className="text-right col-sm-1"
                            onClick={() => this.toggleDetailInfo(this.props.investInfo.investShortName)}
                            >
                            {this.state.open ?
                                <FontAwesomeIcon icon={faCaretDown} className="career_card_caret" />
                                :
                                <FontAwesomeIcon icon={faCaretRight} className="career_card_caret" />
                            }
                        </div>
                    </span>
                   <div className="ml-2">
                            <InvestmentGeneralInfoCard
                                buySell={"buy"}
                                investInfo={this.props.investInfo}
                                investType={this.props.investType}
                                startGameDate={this.moneyBuildInfo.gameData.startGameDate}
                                saveMaturityDate={(maturityDateObj) => this.props.saveMaturityDate(maturityDateObj)}
                            />
                        </div>
                    <div className="text-right mt-2">
                        <label className="font-weight-bold" htmlFor="quantity">
                            Quantity To Purchase:&nbsp;&nbsp;</label>
                            <input type="text" className="col-sm-2" id="quantity" name="quantity"
                                value={this.state.purchaseQuantity}
                                onChange={(e) => this.onPurchaseQuantity(e.target.value)}
                            />
                            <div className="text-danger">{this.errorMsg}</div>
                    </div>
                    {this.purchasePrice  ?
                        <div>
                             <div className="total-line-container">
                                <span className="left-text-placement font-weight-bold">
                                     Click the Review/Confirm Purchases 
                                </span>
                                <span className="right-text-placement">
                                    <span className="font-weight-bold">&nbsp;Total Purchase Amt:&nbsp;&nbsp;</span>
                                    <span className="ml-4">{doubleToStringMonthly(this.purchasePrice)}</span>
                                </span>
                            </div>
                        </div>
                    :
                        null
                    }
                </span>
                {this.state.open   ?
                        <span>
                            <div>
                                {this.displayGraph  ?
                                    <InvestmentPriceGraph
                                        investmentName = {this.props.investInfo.investmentName}
                                        monthNbr={this.currentMonthNbr}
                                        firstMonthDate={this.firstMonthDate}
                                        investType={this.props.investType}
                                        buyDates={this.buyDates}
                                        investShortName={this.props.investInfo.investShortName}
                                        processError = {(errorObj) => this.props.processError(errorObj)}
                                    />
                                :
                                    <div className="mt-2">
                                        The price graph is not shown for bonds because there is not much 
                                        fluctuation in price so the graph is mostly a straight Line
                                        which is not helpful.
                                    </div>
                                }
                            </div>
                            {!this.state.investmentDetailLoaded  ?
                                <WaitTimeSpinner/>
                            :
                                <div>
                                    <div className="font-weight-bold">Summary:</div>
                                        <span>{this.investmentDetailData.summary}</span>
                                    <div>
                                        {this.stockDetailInfo}
                                    </div>
                                </div>
                            }
                        </span>
                :
                    null
                }
        
        </div>
           
    </>
    }

componentWillUnmount(){
    this.setState({open: false});
}

   
loadInvestmentDetail(investShortName){
    const funcName = "investmentInfoArr";
    const urlParm = "?investType=" + this.props.investType + "&investShortName=" + investShortName;
    const uri = buildUrl(this.state.environment, funcName, urlParm);
    fetch (uri,  
            {method:'GET', headers: this.state.headers})
    .then(response => {
        if (response.ok){
            response.json().then(data => {
                const output = JSON.parse(data);
                const statusCode = output.statusCode;
                if (statusCode === 200){
                    this.investmentDetailData = output.body;
                    this.setState({investmentDetailLoaded: true});
                }else{
                    const errorObj={function: funcName, subProcess: this.subProcess, 
                                status: statusCode, message: output.body.message};
                    this.processErrorReturn(errorObj);
                }
            });
        };
    });
}


}

export default InvestmentBuyInfoCard;